import * as GC from '@grapecity/spread-sheets';
import { DEFAULT_DIMENSION_DEFINITION, DEFAULT_DATATABLE_TYPES } from './constants';
import { HoverNotification } from '@interfaces/hover-notification';

export const onMouseMove = (sheet: GC.Spread.Sheets.Worksheet, layerX: number, layerY: number): HoverNotification => {
  const x = layerX;
  const y = layerY;

  const target = sheet.hitTest(x, y);

  if (target) {
    const { row, col } = target;
    const thisCell = sheet.getCell(row, col);
    const value = thisCell.value();
    const validator = thisCell.validator();
    const isValid = sheet.isValid(row, col, value);

    const validationMessages = [
      {
        field: 'Name',
        message: value ? `Lookup Table name can't be empty` : `Lookup Table can't be empty`
      },
      {
        field: 'Mnemonic',
        message: value ? `The Mnemonic should be Unique\nValid characters: a-z, A-Z, 0-9, _` : `Mnemonic can't be empty`
      },
      {
        field: 'Result Type',
        message: value ? `The Result Type should be the word "Numeric"` : `Result Type must be "Numeric"`
      },
      {
        field: 'Datatable Type',
        message: value
          ? `You must select one of the datatable types available in the dropdown menu (e.g. '${DEFAULT_DATATABLE_TYPES.join(
              ', '
            )}')`
          : `No value has been selected`
      },
      {
        field: 'Dimensions',
        message: value ? `You must specify between 1 and 3 dimensions.` : `No value has been selected`
      },
      {
        field: 'Definition',
        message: value
          ? `You must select one of the definition mnemonics available in the dropdown menu (e.g. '${
              DEFAULT_DIMENSION_DEFINITION[0].name
            }')`
          : `No value has been selected`
      },
      {
        field: 'Data Type',
        message: value ? `Data Type must be 'Numeric', 'Text' or 'Date'` : `No value has been selected`
      },
      {
        field: 'Interpolation',
        message: value
          ? `You must select one of the interpolation values available in the dropdown menu (e.g. 'EXACT')`
          : `No value has been selected`
      },
      {
        field: 'Definition',
        message: value
          ? `You must select one of the definition mnemonics available in the dropdown menu (e.g. '${
              DEFAULT_DIMENSION_DEFINITION[0].name
            }')`
          : `No value has been selected`
      },
      {
        field: 'Data Type',
        message: value ? `Data Type must be 'Numeric', 'Text' or 'Date'` : `No value has been selected`
      },
      {
        field: 'Interpolation',
        message: value
          ? `You must select one of the interpolation values available in the dropdown menu (e.g. 'EXACT')`
          : `No value has been selected`
      },
      {
        field: 'Definition',
        message: value
          ? `You must select one of the definition mnemonics available in the dropdown menu (e.g. '${
              DEFAULT_DIMENSION_DEFINITION[0].name
            }')`
          : `No value has been selected`
      },
      {
        field: 'Data Type',
        message: value ? `Data Type must be 'Numeric', 'Text' or 'Date'` : `No value has been selected`
      },
      {
        field: 'Interpolation',
        message: value
          ? `You must select one of the interpolation values available in the dropdown menu (e.g. 'EXACT')`
          : `No value has been selected`
      }
    ];

    let notification: HoverNotification = {};

    const cell = validationMessages[col];
    if (validator && cell && !isValid && row >= 0 && col >= 0) {
      // this.notification = {
      //   title: `Invalid ${cell.field}`,
      //   value: value,
      //   body: `${cell.message}`,
      //   type: 'error'
      // };
      notification = {
        title: `Invalid ${cell.field}`,
        value: value,
        body: `${cell.message}`,
        type: 'error'
      };
    }
    // else {
    //   this.notification = {};
    // }
    return notification;
  }
};
